import React from 'react';
import { IconsPros } from '../icons/types';

/**
 * Webhook Logo component
 *
 * @returns JSX.ELEMENT
 */
export const WebhookLogo = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 256 239" data-testid={dataTestId}>
      <path
        d="m119.5 100.5c-10.6 17.8-20.8 35.1-31.2 52.2-2.7 4.4-4 8-1.9 13.6 5.9 15.5-2.4 30.5-18 34.6-14.7 3.9-29-5.8-31.9-21.5-2.6-13.9 8.2-27.6 23.6-29.8 1.3-0.2 2.6-0.2 4.8-0.4l23.4-39.2c-14.7-14.5-23.4-31.6-21.5-52.8 1.4-15 7.2-27.9 18-38.5 20.6-20.3 52-23.6 76.2-8 23.3 15 33.9 44.1 24.9 69-6.9-1.9-13.8-3.7-21.3-5.8 2.9-13.9 0.7-26.3-8.6-37-6.2-7-14.1-10.7-23.1-12.1-18.1-2.7-35.8 8.9-41.1 26.6-6 20.3 3 36.7 27.7 49.1z"
        fill="#C73A63"
      />
      <path
        d="m149.8 79.4c7.5 13.2 15.1 26.6 22.6 39.8 38-11.8 66.7 9.3 77 31.8 12.4 27.2 3.9 59.5-20.5 76.2-25 17.2-56.7 14.3-78.9-7.9 5.7-4.7 11.3-9.5 17.4-14.6 21.9 14.2 41.1 13.5 55.3-3.3 12.1-14.3 11.9-35.7-0.6-49.8-14.4-16.2-33.7-16.7-57-1.1-9.7-17.2-19.5-34.2-28.9-51.5-3.2-5.8-6.6-9.2-13.8-10.4-11.9-2.1-19.6-12.3-20-23.7-0.5-11.3 6.2-21.5 16.6-25.5 10.3-3.9 22.4-0.8 29.4 8 5.7 7.2 7.5 15.2 4.5 24.1-0.8 2.6-1.9 5-3.1 7.9z"
        fill="#4B4B4B"
      />
      <path
        d="m167.7 187.2h-45.8c-4.4 18-13.9 32.6-30.2 41.9-12.7 7.2-26.4 9.6-40.9 7.3-26.8-4.3-48.7-28.5-50.6-55.7-2.2-30.8 19-58.1 47.2-64.3 1.9 7.1 3.9 14.2 5.9 21.3-25.9 13.2-34.8 29.8-27.6 50.6 6.4 18.3 24.5 28.3 44.1 24.5 20.1-4 30.2-20.6 29-47.4 19 0 38.1-0.2 57.1 0.1 7.4 0.1 13.2-0.7 18.8-7.2 9.2-10.8 26.2-9.8 36.1 0.4 10.1 10.4 9.7 27.2-1.1 37.1-10.4 9.6-26.7 9.1-36.4-1.3-2.1-2.1-3.6-4.7-5.6-7.3z"
        fill="#4A4A4A"
      />
    </svg>
  );
};
